module.exports = __webpack_public_path__ + "img/map.44666b3f.png";